import { formatRequestString } from '../../../utils/helpers/api/queryString'
import { API } from '../../../utils/api/api'
import {
  PutProcessingActivityAssessmentFileRequestBody,
  PutProcessingActivityAssessmentFileResponseBody,
} from '@ketch-com/windlass/dist/processingActivities/processingActivities'

interface PutProcessingActivityAssessmentFileParams extends PutProcessingActivityAssessmentFileRequestBody {
  processingActivityId: string
}

export const putProcessingActivityAssessmentFile = ({
  processingActivityId,
  file,
}: PutProcessingActivityAssessmentFileParams) => {
  const entityUrl = `/api/risk-review/processing-activities/${processingActivityId}/assessment-file`
  return API.put<PutProcessingActivityAssessmentFileResponseBody>(formatRequestString({ entityUrl }), {
    file,
  })
}
